import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Register from './components/Register';
import ProfileList from './components/ProfileList';
import ProfilePage from './components/ProfilePage';
import AnalysisPage from './components/AnalysisPage';
import BrowseProfiles from './components/BrowseProfiles';

import ProfileSettings from './components/ProfileSettings';
import Footer from './components/Footer';

export default function App() {
  const { currentUser } = useAuth();
  
  return (
    <>
      <Navbar />
      <Routes>
        {/* Home - redirect to user's grades if logged in, else ProfileList */}
        <Route path="/" element={
          currentUser ? 
            <Navigate to={`/users/${currentUser.id}`} replace /> : 
            <PrivateRoute><ProfileList /></PrivateRoute>
        } />

        {/* Browse Profiles page */}
        <Route path="/browse" element={
          <PrivateRoute><BrowseProfiles /></PrivateRoute>
        } />

        {/* Profile Settings */}
        <Route path="/profile" element={
          <PrivateRoute><ProfileSettings /></PrivateRoute>
        } />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/users/:id" element={
            <PrivateRoute><ProfilePage /></PrivateRoute>
          } />
          <Route path="/analysis" element={
            <PrivateRoute><AnalysisPage /></PrivateRoute>
          } />
        </Routes>
      <Footer />
    </>
  );
}
